import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 426px;

  img {
    width: 64px;
    height: 64px;
    margin: 24px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 150%;
  color: #3d4456;
  text-align: center;
  margin-bottom: 10px;
`;

export const Description = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #999999;
  max-width: 330px;

  b {
    color: #999999;
  }
`;

export const ContainerFooter = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  margin-top: 32px;
  justify-content: center;
  align-items: center;

  button {
    font-weight: bold;
    width: fit-content;
  }
`;
